import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CMASummaryTableDataValuesDifference from './CMASummaryTableDataValuesDifference';
import { CMA_SUMMARY_REVIEW_TYPE_DATA_ROW } from './constants';
import { getNumberOfReviewsTestId } from './testIdUtils';
import { CMASummaryFilters } from './types';
import { parseCMASummaryCommunityData } from './utils';

const Title = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
`;

const Subtitle = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
`;

type Props = {
  reviews: number[];
  dataTestId?: string;
  expandedRowKeys: string[];
};

const CMASummaryTableDataReview = ({ reviews, expandedRowKeys, dataTestId }: Props) => {
  const { viewFilters } = useCommunityViewContext();

  if (!reviews?.length) return null;

  const filters = viewFilters as CMASummaryFilters;

  const { dataItemOne, dataItemTwo } = parseCMASummaryCommunityData(reviews, filters?.viewOptions?.valueDisplay);

  const parsedAverage = dataItemOne?.value;
  const averageDifference = dataItemOne?.difference;
  const parsedTotal = dataItemTwo?.value;
  const totalDifference = dataItemTwo?.difference;

  const sourceReviews = reviews.slice(2);

  const showExpandedRows = expandedRowKeys.includes(CMA_SUMMARY_REVIEW_TYPE_DATA_ROW) && (parsedAverage || parsedTotal);

  return (
    <div>
      <Title data-test-id={dataTestId}>
        {parsedAverage} <CMASummaryTableDataValuesDifference prefix="" difference={averageDifference} />
      </Title>

      <Subtitle data-test-id={getNumberOfReviewsTestId(dataTestId)}>
        {parsedTotal && <span>{parsedTotal} reviews</span>}
        <CMASummaryTableDataValuesDifference prefix="" difference={totalDifference} />
      </Subtitle>

      {showExpandedRows &&
        sourceReviews.map((review: any, idx: number) => {
          if (!review) {
            return (
              <Subtitle key={idx} data-test-id={`${dataTestId}-number-of-reviews-value`}>
                -
              </Subtitle>
            );
          }

          const [value, source] = review.split(',');

          return (
            <Subtitle key={idx} data-test-id={`${dataTestId}-number-of-reviews-value-${source}`}>
              {value} reviews
            </Subtitle>
          );
        })}
    </div>
  );
};

export default CMASummaryTableDataReview;
